import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

import InnerComponent from './InnerComponent';

// eslint-disable-next-line
const LeavePageBoundary = ({ isEnabled }: { isEnabled: boolean }) => {
  return (
    <ReactErrorBoundary fallbackRender={() => null} onError={() => {}}>
      <InnerComponent isEnabled={isEnabled} />
    </ReactErrorBoundary>
  );
};

export default LeavePageBoundary;
